
import { Routes, Route, BrowserRouter,Outlet } from 'react-router-dom';
import './App.css';
import MainLayout from './layouts/MainLayout';
import PlainLayout from './layouts/PlainLayout';
import About from './pages/About';
import SignUp from './pages/SignUp';
import RegisterProfessional from './pages/RegisterProfessional';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from  './pages/PrivacyPolicy';
import Payment from './pages/Payment';
import Events from './pages/Events';
import EventDetails from './components/EventDetails';
import AdminDashBoard from './admin/AdminDashBoard';
import Authentication from './admin/Authentication';
import AuthProvider  from './components/AuthProvider';
import ProtectedRoute from './components/ProtectedRoute';


function App() {
  return (
    <Routes>
      {/* Pages WITH layout */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<SignUp />} />
        <Route path="/register" element={<SignUp />} />
        <Route path="/about" element={<About />} />
        <Route path="/register_professional" element={<RegisterProfessional />} />
        <Route path="/events" element={<Events />} />
        <Route path="/eventdetails" element={<EventDetails />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/success" element={<Payment result="success" />} />
        <Route path="/cancel" element={<Payment result="cancel" />} />
      </Route>

        <Route element={
          <AuthProvider>
            <Outlet /> {/* Renders the matching child route below */}
          </AuthProvider>
        }>
          <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
              <Route path="/dashboard" element={<AdminDashBoard />} />
          </Route>
          <Route element={<PlainLayout />}>
            <Route path="/admin" element={<Authentication />} />
          </Route>
        </Route>
      </Routes>
  );
}

export default App;
